import { ROLE_ACCESS, RoleEnum } from './role';

export interface MenuItem {
  label: string;
  icon: string;
  routerLink?: string;
  exact?: boolean;
  roles: RoleEnum[];
  cssClass?: string;
  subItems?: MenuItem[];
  isSection?: boolean;
  stateKey?: 'adminOpen';
}

export const SIDEBAR_MENU: MenuItem[] = [
  {
    label: 'Recepción',
    icon: 'fa-solid fa-clipboard-check',
    routerLink: '/operations/reception',
    roles: ROLE_ACCESS['reception'],
  },
  {
    label: 'Técnico',
    icon: 'fa-solid fa-screwdriver-wrench',
    routerLink: '/operations/work-orders',
    exact: true,
    roles: ROLE_ACCESS['technical'],
  },
  {
    label: 'Administración',
    icon: 'fa-solid fa-sliders',
    isSection: true,
    stateKey: 'adminOpen',
    roles: ROLE_ACCESS['reception'],
    subItems: [
      {
        label: 'Cotizaciones',
        icon: 'fa-solid fa-file-invoice-dollar',
        routerLink: '/operations/quotes',
        exact: true,
        roles: ROLE_ACCESS['reception'],
        cssClass: 'sidebar__subitem',
      },
      {
        label: 'Historial de órdenes',
        icon: 'fa-solid fa-clock-rotate-left',
        routerLink: '/admin/orders-history',
        exact: true,
        roles: ROLE_ACCESS['admin'],
        cssClass: 'sidebar__subitem',
      },
      {
        label: 'Directorio de clientes',
        icon: 'fa-solid fa-users',
        routerLink: '/admin/customers',
        exact: true,
        roles: ROLE_ACCESS['admin'],
        cssClass: 'sidebar__subitem',
      },
      {
        label: 'Catálogo de servicios',
        icon: 'fa-regular fa-folder-open',
        routerLink: '/admin/services-catalog',
        exact: true,
        roles: ROLE_ACCESS['admin'],
        cssClass: 'sidebar__subitem',
      },
      {
        label: 'Usuarios',
        icon: 'fa-solid fa-user-gear',
        routerLink: '/admin/users',
        exact: true,
        roles: ROLE_ACCESS['admin'],
        cssClass: 'sidebar__subitem',
      },
    ],
  },
];
